<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <b-card-title>{{$t("campaigns.contents")}}</b-card-title>

          <div>
            <b-dropdown
              no-caret
              right
              variant="transparent"
              class="chart-dropdown mr-1 mt-1"
              toggle-class="p-50"
              size="sm"
            >
              <template #button-content>
                <b-button
                  :class="`button-full-width`"
                  variant="outline-primary"
                  @click="iconShort = !iconShort"
                >
                  {{ sortLabel }}
                  <b-icon
                    :icon="iconShort ? 'chevron-down' : 'chevron-up'"
                  ></b-icon>
                </b-button>
              </template>

              <b-dropdown-item
                v-for="sort in sortsDropdown"
                :key="sort.value"
                @click="changeSort(sort)"
              >
                <span>{{ $t(`media_tt.${sort.label}`) }}</span>
              </b-dropdown-item>
            </b-dropdown>
            <b-dropdown
              no-caret
              right
              variant="transparent"
              class="chart-dropdown"
              toggle-class="p-50 mt-1"
              size="sm"
            >
              <template #button-content>
                <b-button
                  :class="`button-full-width`"
                  variant="outline-primary"
                  @click="iconDay = !iconDay"
                >
                  {{ dayLabel }}
                  <b-icon :icon="iconDay ? 'chevron-down' : 'chevron-up'"></b-icon
                ></b-button>
              </template>
              <b-dropdown-item
                v-for="day in dayDropdown"
                :key="day.value"
                @click="changeDay(day)"
              >
                <span>{{ $t(`period_media_tt.${day.label}`) }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        

        <b-row v-if="mediaFiltered.length === 0" class="my-1 col-12">
          <b-col class="text-start">
            <h3>N/D</h3>
            <span class="text-muted">{{ $t("campaigns.noDataContent") }}</span>
          </b-col>
        </b-row>
      </b-card-header>
    </b-card>

    <b-row class="match-height justify-content-center" v-if="!loading_cards">
      <b-col
        class="col-12 col-md-5 col-lg-3 mr-lg-2 ml-lg-2 p-lg-0"
        v-for="(media, index) in mediaFiltered"
        :key="index"
      >
        <b-card
          no-body
          class="card hover-card card-image-content card-type-content p-1"
        >
        <div class="mb-1 d-flex align-items-center">
          <div class="position-relative mr-1">
            <b-avatar
              size="3.5rem"
              variant="light-secondary"
              :src="verifyAsset(media.avatar)"
            ></b-avatar>
            <b-avatar
              class="icon-network p-0 position-absolute"
              variant="light"
              size="20px"
            >
              <b-img
                :src="`${getIconWhite('tiktok')}`"
                :class="getIconColor('tiktok', false)"
                fluid
              ></b-img>
            </b-avatar>
          </div>

            <div class="d-flex flex-column">
              <span>
                {{ media.username }} 
                <image-verified v-if="media.is_verified == true"/></span>
              <small class="text-muted">
                {{$t("campaigns.post")}}  · {{getTimePost(media.basic.exact_create_time)}}
              </small>
            </div>
          </div>

          
          <b-link :href="formatLink(media)" target="_blank">
            <b-img-lazy
              class="card-image-content"
              :src="media.basic.thumbnail || backgroundDefault"
              @error.native="errorLoad(index, media)"
            />
          </b-link>
          <div class="card-content-all">
            <div class="container-interactions">
             

              <div class="w-100 avenir-light mb-05 mt-1">
               <b-badge
                class="badge-er w-100"
                pill>
                <b-badge
                  :variant="colorBadge(media.metrics.er.mark)"
                  pill
                  class="badge-circle mr-05"
                >&nbsp;</b-badge>
                 ER {{ media.metrics.er.value ? `${getFormat(media.metrics.er.value)} %` : $t("tracking.notAvailable") }} |  {{ traductionMark(media.metrics.er.mark) }}
                </b-badge>
              </div>
              <div class="d-flex justify-content-between align-items-center w-100 avenir-light mb-05 flex-wrap">
                <div class="d-flex align-items-center">
                  <div
                    class="d-flex align-items-center mr-05"
                    v-if="media.metrics.views_count.value > 0"
                  >
                    <b-icon class="mr-05" icon="play-circle" />
                    <span>{{ media.metrics.views_count.value ? getFormat(media.metrics.views_count.value) : 0 }}</span>
                  </div>
                  <div class="d-flex align-items-center mr-05">
                    <b-icon class="mr-05" icon="heart-fill" />
                    <span>{{ media.metrics.likes_count.value ? getFormat(media.metrics.likes_count.value) : $t("campaigns.hiddenCreator") }}</span>
                  </div>
                  <div class="d-flex align-items-center mr-05">
                    <b-icon class="mr-05" icon="chat" />
                    <span>{{ media.metrics.comments_count.value ? getFormat(media.metrics.comments_count.value) : 0 }}</span>
                  </div>
                </div>


                <div>
                  <b-link class="text-dark" :href="formatLink(media)" target="_blank">
                    <feather-icon icon="ExternalLinkIcon" size="20"></feather-icon>
                  </b-link>
               </div>
              </div>
              <div class="metric-row">
                <span class="avenir-light">{{ $t('campaigns.shareTime')}}</span>
                <span class="metric-line"></span>
                <span class="avenir-light">{{ media.metrics.shares_count.value ? getFormat(media.metrics.shares_count.value) : 0 }}</span>
              </div>
    
              <div class="text-start mb-05 avenir-light w-100">
                <p>
                  {{ shortText(number_words, media.basic.text) }}
                  <b-link :href="formatLink(media)" target="_blank" class="text-link text-start ml-1 cursor-pointer"
                    v-if="media.basic.text && media.basic.text.split(' ').length > number_words">
                    <span :id="`view${index}`">{{$t('instagram.seeMore')}}</span> 
                  </b-link>
                  <b-tooltip :target="`view${index}`" variant="primary"
                    :title="media.basic.text" placement="bottom"
                    custom-class="tooltip-contents-view" />
                </p>
              </div>

            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <div class="col-12 row m-0 p-0 justify-content-center" v-if="loading_cards">
      <b-col class="col-12 col-md-5 col-lg-3 mr-lg-2 ml-lg-2 p-lg-0" v-for="i in 6" :key="i">
        <b-card>
          <div class="d-flex align-items-center mb-1">
            <b-skeleton type="avatar" width="55px" height="55px" class="mr-2" />
            <div>
              <b-skeleton width="120px" />
              <b-skeleton width="80px"/>
            </div>
          </div>

          <b-skeleton type="image" width="100%" height="250px" class="mb-2" />

          <b-skeleton/>
          <b-skeleton/>
          <b-skeleton/>

        </b-card> 
      </b-col>
    </div>
  </div>
</template>
  
<script>
import {
  BAvatar,
  BImg,
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BDropdown,
  BDropdownItem,
  BImgLazy,
  BIcon,
  BLink,
  BButton,
  BTooltip,
  BBadge,
  BSkeleton,
} from "bootstrap-vue";
import { getFormat, shortText } from "@/libs/utils/formats";
import { getDatev2, getTimePost } from "@/libs/utils/times";
import { getIconWhite, getIconColor, getImageNetworkColor } from "@/libs/utils/icons";
import { verifyAsset } from "@/libs/utils/urls";
import profile_services from "@/services/profile";

export default {
  name: "TiktokMedia",
  components: {
    BSkeleton,
    BAvatar,
    BImg,
    BBadge,
    BTooltip,
    BButton,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BImgLazy,
    BIcon,
    BLink,
    ImageVerified: () => import('@/views/components/image/ImageVerified.vue'),
  },
  props: {
    contents: {
      type: Array,
      default: () => [],
    },
    media_ids: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      getTimePost,
      getIconWhite,
      getIconColor,
      verifyAsset,
      getFormat,
      getDatev2,
      getImageNetworkColor,
      shortText,
      backgroundDefault: require("@/assets/images/dashboard/imgDefault.png"),
      own_number_words: this.number_words,
      iconShort: true,
      iconDay: true,
      day_selected: "last_30",
      sort_selected: "most_recent_media",
      number_words: 5,
      loading_cards: false,
    };
  },
  computed: {
    sortLabel() {
      const sort = this.sortsDropdown.find((s) => s.label === this.sort_selected);
      if (!sort) return "";

      return this.$t(`media_tt.${sort.label}`);
    },

    dayLabel() {
      const day = this.dayDropdown.find((d) => d.label === this.day_selected);
      if (!day) return "";

      return this.$t(`period_media_tt.${day.label}`);
    },

    sortsDropdown() {
      return [
        { label: "most_recent_media", value: "most_recent_media" },
        { label: "most_engaging_media", value: "most_engaging_media" },
        { label: "most_viral_media", value: "most_viral_media" },
        { label: "most_commented_media", value: "most_commented_media" },
        { label: "most_viewed_media", value: "most_viewed_media" },
      ];
    },

    dayDropdown() {
      return [
        { label: "last_30", value: 30 },
        { label: "last_90", value: 90 },
        { label: "last_180", value: 180 },
        { label: "last_365", value: 365 },
      ];
    },
    selectedKeys() {
      const sort_map_tiktok = {
        most_recent_media: "most_recent_media",
        most_engaging_media: "most_engaging_media",
        most_viral_media: "most_viral_media",
        most_commented_media: "most_commented_media",
        most_viewed_media: "most_viewed_media",
      };
      const day_map_tiktok = {
        last_30: "30d",
        last_90: "90d",
        last_180: "180d",
        last_365: "365d",
      };

      return {
        sort_selected: sort_map_tiktok[this.sort_selected] || "most_recent_media",
        day_selected: day_map_tiktok[this.day_selected] || "30d",
      };
    },

    mediaFiltered() {
      const { sort_selected, day_selected } = this.selectedKeys;
      const media_section = this.media_ids?.[sort_selected];
      const ids_filters = media_section?.performance?.[day_selected]?.media_ids || [];
      return this.contents.filter((item) => ids_filters.includes(item.id));
    },
  },
  created() {
  },
  watch: {
    selectedKeys: {
      handler() {
        this.loading_cards = true;
        setTimeout(() => {
          this.loading_cards = false;
        }, 300);
      },
      deep: true
    }
  },
  methods: {
    traductionMark(mark) {
      if (mark === 'high' || mark === 'very_good' || mark === 'excellent') {
        return this.$t('campaigns.high');
      } else if (mark === 'good') {
        return this.$t('campaigns.good');
      } else if (mark === 'low' || mark === 'fair') {
        return this.$t('campaigns.low');
      } else if (mark === 'average' || mark === 'fair') {
        return this.$t('campaigns.average');
      }
      return '';
    },
    colorBadge(mark) {
      if (mark === 'high' || mark === 'good' || mark === 'very_good' || mark === 'excellent') return 'success';
      if (mark === 'low' || mark === 'fair') return 'warning';
      if (mark === 'average' || mark === 'fair') return 'danger';
      return 'secondary';
    },
    getPreview(username, id, media) {
      profile_services.getPreviewTiktok(username, id)
        .then((response) => {
          const previewData = response?.thumbnail_url;
          if (previewData) {
            this.$set(media.basic, 'thumbnail', previewData);
          } else {
            this.$set(media.basic, 'thumbnail', this.backgroundDefault);
          }
        })
    },
    changeSort(sort) {
      this.iconShort = true;
      this.sort_selected = sort.label;
    },
    changeDay(day) {
      this.iconDay = true;
      this.day_selected = day.label;
    },
    async errorLoad(index, media) {
      this.$set(this.contents[index].basic, 'thumbnail', this.backgroundDefault);
      if (media.username && media.id) {
        await this.getPreview(media.username, media.id, media);
      }
    },
    formatLink(media) {
      return `https://www.tiktok.com/@${media.username}/video/${media.basic.id}`;
    },
  },
};
</script>
  
<style>
.icon-network {
    position: relative;
    top: 30px;
    z-index: 9;
    background: white;
    border-radius: 50%;
    bottom: 0;
    right: 0;
  }
.badge-circle {
  width: 7px !important;
  height: 7px  !important;
  padding: 0;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}
.badge-er {
  background-color: #f5f8fa;
  color: black;
}
.metric-row {
  display: flex;
  align-items: center;
  width: 100%;
}
.metric-line {
  flex-grow: 1;
  border-bottom: 1px dashed #ccc;
  margin: 0 8px;
}
.button-full-width {
  width: 175px !important;
}
.hover-card:hover {
  transform: scale(1.05);
  transition: all 500ms;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}
.card-image-content {
  width: 100%;
  object-fit: cover;
  height: 300px;
  border-radius: 1%;
}
.card-content-all {
  width: 100%;
}
.card-type-content {
  display: flex;
  height: 90%;
}
.icon-network-media {
  position: relative;
  width: 15px !important;
  height: 15px !important;
  left: 23px;
  bottom: -75px;
  z-index: 2;
}
.container-interactions {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.avatar-style {
  background-color: light;
}
.influencer-username {
  margin-top: 1rem;
  font-weight: bold;
}
.max-width-100 {
  max-width: 100%;
}
</style>
  